import React, { Component } from 'react';
import './styles.scss';

export default class PageHeading extends Component {
  render() {
    return (
      <h3 className="page-heading" to="/">{this.props.children}</h3>
    );
  }
}
